export const BORDER_COLOR_AROUND = 'border-color-around';
export const BORDER_COLOR_ALL = 'border-color-all';
export const DELETE_ROW = 'delete-row';
export const DELETE_COLUMN = 'delete-column';
export const DELETE_TABLE = 'delete-table';
export const INSERT_ABOVE = 'insert-above';
export const INSERT_BELOW = 'insert-below';
export const INSERT_LEFT = 'insert-left';
export const INSERT_RIGHT = 'insert-right';
export const DISTRIBUTE_COLUMNS = 'distribute-columns';
export const DISTRIBUTE_ROWS = 'distribute-rows';
export const SELECT_COLUMN = 'select-column';
export const CLEAR = 'clear';
